import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import FadeIn from '../../../molecules/Transitions/FadeIn'
import { planning } from '../../../../api/integrations'
import SydButton from '../../../commonDesign/Button'
import ComparisonCard from './ComparisonCard'

const useStyles = makeStyles({
  befi20: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  personaIcon: {},
  individualResults: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h1': {
      padding: 0,
      margin: 0,
      fontWeight: 'bold',
      fontSize: '2.8rem',
      textAlign: 'center'
    },
    '& p': {
      padding: '1rem 2rem',
      margin: 0,
      fontSize: '1rem',
      textAlign: 'center'
    }
  },
  comparisons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h2': {
      textAlign: 'center'
    },
    '& .__comparison-container': {
      display: 'flex',
      flexDirection: 'row',
      gap: '1rem'
    }
  }
})

function BeFi20View ({ clientId, cardClassName }) {
  const {
    data,
    isLoading
  } = planning.usePlanningQuery({
    queryType: 'befi20',
    payload: { clientId }
  })

  const styles = useStyles()

  if (isLoading) return null

  // TODO: I'm not quite sure what the other responses are
  const iconText = data.individualResults?.header === 'You are a Maximizer.' ? 'MaximizerIcon' : 'ShrugIcon'

  return (
    <FadeIn>
      <div className={styles.befi20}>
        <span className={styles.personaIcon}>{iconText}</span>
        <div className={styles.individualResults}>
          <h1>{data.individualResults?.header}</h1>
          <p>{data.individualResults?.description}</p>
          <SydButton variant='primary'>View Details</SydButton>
        </div>
        <div className={styles.comparisons}>
          <h2>Your Comparisons</h2>
          <div className='__comparison-container'>
            {data.comparisons.map((c, i) => (
              <ComparisonCard {...c} key={i} />
            ))}
          </div>
        </div>
      </div>
    </FadeIn>
  )
}

BeFi20View.propTypes = {
  clientId: PropTypes.number,
  cardClassName: PropTypes.string
}

BeFi20View.defaultProps = {
  cardClassName: 'opal-card-md'
}

export default BeFi20View
